import React from 'react';
import { Table, TableContainer } from '@mui/material';

export default function ResponsiveTable({ children, minWidth = 720, label }) {
  return (
    <TableContainer sx={{ overflowX: 'auto', maxWidth: '100%' }}>
      <Table sx={{ minWidth }} aria-label={label}>
        {children}
      </Table>
    </TableContainer>
  );
}
